export default "__VITE_ASSET__B18gUIkE__"